import { render } from "./ColumnWithDataLabelsChart.vue?vue&type=template&id=0256d66f&ts=true"
import script from "./ColumnWithDataLabelsChart.vue?vue&type=script&lang=ts"
export * from "./ColumnWithDataLabelsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__